const React = require('react');

/* eslint-disable */

module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M24.3488 9.456C24.0837 4.188 20.0075 0 15 0C9.99375 0 5.91625 4.188 5.65125 9.456C2.43875 10.0733 0 13.064 0 16.6667C0 20.716 3.07875 24 6.875 24H23.125C26.9212 24 30 20.716 30 16.6667C30 13.064 27.5613 10.0733 24.3488 9.456ZM15 8L20 13.3333H16.25V18.6667H13.75V13.3333H10L15 8Z"
      />
    </svg>
  );
};
